module.exports = __webpack_public_path__ + "img/calco2ai.f957acd2.png";